import React from "react";
import styled from "styled-components";
import teamMember1 from "../../assets/team_member1.png";
import teamMember2 from "../../assets/team_member2.png";
import teamMember3 from "../../assets/team_member3.png";
import Button from "../Button";

const Team = () => {
 
  return (
    <TeamSection>
      <TeamContent>
        <TeamTextContent>
          <TeamTitleTag>Notre</TeamTitleTag>
          <TeamTitle>Équipe</TeamTitle>

          <TeamDescription>
            Découvrez qui se cache derrière OlaSoft. Une équipe passionnée, dévouée et soudée, qui met tout en œuvre pour vous offrir les meilleures solutions.
          </TeamDescription>

          <QuoteBox>
            <QuoteIconTop>“</QuoteIconTop>
            <QuoteText>
              Chaque membre compte, et c'est ensemble que nous faisons grandir OlaSoft jour après jour.
              <QuoteIconBottom>“</QuoteIconBottom>
            </QuoteText>
          </QuoteBox>
          
          <Button 
            background="#1e1b3d"
            color="#ffffff"
            hoverBackground="#2a2649"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            Découvrir L'équipe
            <ArrowIcon>→</ArrowIcon>
          </Button>
        </TeamTextContent>

        <ContentRight className="content-right">
          <TeamVisuals>
            {/* Figure 1 */}
            <Figure1 className="figure1">
              <img
                src={teamMember1}
                alt="Membre de l'équipe 1"
              />
            </Figure1>

            {/* Figure 2 */}
            <Figure2 className="figure2">
              <img
                src={teamMember2}
                alt="Membre de l'équipe 2"
              />
            </Figure2>

            {/* Figure 3 */}
            <Figure3 className="figure3">
              <img
                src={teamMember3}
                alt="Membre de l'équipe 3"
              />
            </Figure3>
          </TeamVisuals>
        </ContentRight>
      </TeamContent>
    </TeamSection>
  );
};

export default Team;

// Styles avec les mêmes marges que la navbar
const TeamSection = styled.section`
  background: linear-gradient(135deg, #b8b5e6 0%, #c5c3f0 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  font-family: Raleway;

  @media (max-width: 1200px) {
    padding: 60px 0;
  }

  @media (max-width: 968px) {
    padding: 50px 0;
  }
`;

const TeamContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  width: 95vw;
  margin: 0 auto;
  gap: 12vw;
  font-family: Raleway;
  
  // Mêmes marges que la navbar (2.5vw de chaque côté)
  padding: 5.76vw 3.448vw;

  @media (max-width: 1400px) {
    gap: 80px;
  }

  @media (max-width: 1200px) {
    gap: 50px;
  }

  @media (max-width: 968px) {
    flex-direction: column;
    gap: 60px;
    width: 90vw;
    padding: 0;
  }
`;

const TeamTextContent = styled.div`
  flex: 1;
  max-width: 550px;
  font-family: Raleway;

  @media (max-width: 968px) {
    max-width: 100%;
  }
`;

const ContentRight = styled.div`
  flex: 1;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 72vw;
  }
`;

const TeamTitleTag = styled.h3`
  font-size: 48px;
  font-weight: 500;
  color: #7c7a9e;
  margin-bottom: 5px;
  letter-spacing: -0.5px;
  font-family: Raleway;

  @media (max-width: 1200px) {
    font-size: 38px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
  }
`;

const TeamTitle = styled.h2`
  font-size: 56px;
  font-weight: 700;
  color: #1e1b3d;
  letter-spacing: -1px;
  font-family: Raleway;

  @media (max-width: 1200px) {
    font-size: 46px;
  }

  @media (max-width: 640px) {
    font-size: 38px;
  }
`;

const TeamDescription = styled.p`
  font-size: 16px;
  line-height: 1.75;
  color: #4a4768;
  margin-bottom: 50px;
  font-family: Raleway;
`;

const QuoteBox = styled.div`
  margin-bottom: 50px;
  position: relative;
  padding-left: 40px;
  font-family: Raleway;

  @media (max-width: 640px) {
    padding-left: 30px;
  }
`;

const QuoteIconTop = styled.span`
  position: absolute;
  left: 0;
  top: -10px;
  font-size: 48px;
  font-weight: 900;
  color: #1e1b3d;
  font-family: Raleway;
  line-height: 1;

  @media (max-width: 640px) {
    font-size: 36px;
  }
`;

const QuoteText = styled.p`
  font-size: 28px;
  font-weight: 400;
  line-height: 1.5;
  color: #1e1b3d;
  margin-bottom: 0;
  font-family: Raleway;

  @media (max-width: 1200px) {
    font-size: 24px;
  }

  @media (max-width: 640px) {
    font-size: 20px;
  }
`;

const QuoteIconBottom = styled.span`
  display: inline-block;
  font-size: 48px;
  font-weight: 900;
  color: #1e1b3d;
  font-family: Raleway;
  margin-left: 10px;
  line-height: 1;
  vertical-align: bottom;

  @media (max-width: 640px) {
    font-size: 36px;
  }
`;

const ArrowIcon = styled.span`
  font-size: 20px;
  transition: transform 0.3s ease;
  font-family: Raleway;

  button:hover & {
    transform: translateX(5px);
  }
`;

const TeamVisuals = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 500px;
  font-family: Raleway;

  /* Supprimer le min-height sur mobile */
  @media (max-width: 768px) {
    min-height: unset;
    height: auto;
  }
`;

// Styles pour les figures avec les réglages CSS fournis
const FigureBase = styled.figure`
  position: absolute;
  z-index: 5;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
`;

const Figure1 = styled(FigureBase)`
  top: -2vw;
  left: -11vw;
  width: 30.87vw;
  height: 36.938vw;
  background:#161645;
  clip-path: polygon(61% 1%, 97% 54%, 47% 97%, 5% 41%);

  @media (max-width: 768px) {
    width: 56.87vw;
    height: 67.938vw;
    left: -3vw;
    top: 0vw;
  }
`;

const Figure2 = styled(FigureBase)`
  top: -1.94vw;
  left: 9.4vw;
  width: 29.79vw;
  height: 18.987vw;
  background: #f7b603;
  clip-path: polygon(61% 0, 100% 100%, 36% 100%, 0 0);

  @media (max-width: 768px) {
    top: -.94vw;
    left: 35.4vw;
    width: 55.79vw;
    height: 35.987vw;
  }
`;

const Figure3 = styled(FigureBase)`
  top: 18.41vw;
  left: 4.8vw;
  width: 35.26vw;
  height: 16.271vw;
  background: #FF3D00;
  clip-path: polygon(100% 0, 56% 99%, 0 100%, 45% 0);

  @media (max-width: 768px) {
    top: 37.41vw;
    left: 28.8vw;
    width: 61.26vw;
    height: 29.271vw;
  }
`;